import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const tokens = authService.getToken();

  if (tokens?.accessToken) {
    return true;
  }

  router.navigate(['/auth/login']);
  return false;
};
